import React from 'react';

import WelcomeFeature from '@features/welcome';
import { useFormStore } from '@store/use-form-store';

import { useExternalElearningFlow } from './shared/eel-flow-context';

function ExternalElearningWelcomePage() {
  const { goNext } = useExternalElearningFlow();
  const { changeRegistrationType, resetProcess } = useFormStore();

  const handleRegister = (type: string) => {
    resetProcess();
    changeRegistrationType(type);
    goNext();
  };

  return (
    <WelcomeFeature
      onSingleRegister={() => handleRegister('single')}
      onMultipleRegister={() => handleRegister('multiple')}
    />
  );
}

export default ExternalElearningWelcomePage;
